module.exports = __webpack_public_path__ + "static/media/jc.f1899e59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jc.jpg
// module id = 200
// module chunks = 0